import { RecordHistoryPage } from '@/components/audit-log/RecordHistoryPage'
import { usePathHelper } from '@/hooks/usePathHelper'
import { adminTitleHead } from '@/lib/admin-route-title'
import { auditLogQueries } from '@/lib/services/audit-log/audit-log.query'
import { organizationBillingSettingsQueries } from '@/lib/services/organization-billing-settings/organization-billing-settings.query'
import { createFileRoute, notFound } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/$orgId/settings/billing/history')({
  component: BillingSettingsHistoryPage,
  head: () => adminTitleHead('History', 'Billing Settings', 'Settings'),
  loader: async ({ context, params }) => {
    if (
      !context.ability.can('list', 'billing-settings') ||
      !context.ability.can('view', 'audit-logs')
    ) {
      throw notFound()
    }

    await Promise.all([
      context.queryClient.ensureQueryData(
        organizationBillingSettingsQueries.detail({ organizationId: params.orgId })
      ),
      context.queryClient.ensureInfiniteQueryData(
        auditLogQueries.record({
          organizationId: params.orgId,
          subject: 'customer-billing-defaults',
          recordId: params.orgId,
        })
      ),
    ])
  },
})

function BillingSettingsHistoryPage() {
  const { orgId } = Route.useParams()
  const path = usePathHelper()

  return (
    <RecordHistoryPage
      backLabel="billing settings"
      backLink={path.billing.index().link}
      description="Review changes to the billing defaults copied to new customers."
      organizationId={orgId}
      recordId={orgId}
      recordLabel="Billing settings"
      subject="customer-billing-defaults"
    />
  )
}
